import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux'
import { Footer } from '../../components'
import { useAppContext } from '../App/Context'
import { selectStyles } from '../App/selectors'
import LanguageProvider from '../LanguageProvider/LanguageProvider'
import { fetchFooter } from './actions'
import { selectFooter, selectIsFetching } from './selectors'

const FooterContainer = props => {
  const { fetchFooter, language, footer, isFetching } = props
  const { versionKey: version } = useAppContext()

  useEffect(() => {
    if (version !== 'v1') {
      fetchFooter(language.substring(0, 2), version)
    }
  }, [])

  if (isFetching || (Object.keys(footer).length === 0 && version !== 'v1'))
    return (
      <div className="flex">
        <FontAwesomeIcon icon={faSpinner} spin />
      </div>
    )
  return <Footer {...props} version={version} />
}

const mapStateToProps = state => ({
  styles: selectStyles(state),
  footer: selectFooter(state),
  isFetching: selectIsFetching(state)
})

const mapDispatchToProps = dispatch => ({
  fetchFooter: (language, version) =>
    dispatch(fetchFooter.request(language, version))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageProvider(FooterContainer))



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js